import * as React from "react";
import {useLocationCode} from "@variocube/cube-ui";
import {stylesheet} from "typestyle";
import {useLocalization} from "../../i18n";

export function LocationCodeOverlay() {
    const locationCode = useLocationCode();
    const {t} = useLocalization();
    return (
        <div className={styles.locationCodeOverlay}>
            <div className={styles.label}>
                {t("CubeCode")}
            </div>
            <div className={styles.code}>
                {locationCode}
            </div>
        </div>
    );
}

const styles = stylesheet({
    locationCodeOverlay: {
        position: "absolute",
        top:0,
        right:0,
        color: "#000",
        display: "flex",
        flexFlow: "row nowrap",
        justifyContent: "flex-end",
        alignItems: "center",
        backgroundColor: "#F0BF31",
        boxShadow: "1px 1px 3px #000",
        padding: "0 0.75em",
    },
    label: {
        display: "block",
        padding: "0 0.25em",
        whiteSpace: "pre",
        textAlign: "right",
        textTransform: "uppercase",
        marginRight: "0.25em",
        opacity: "0.66",
    },
    code: {
        display: "block",
        fontSize: "3em",
    }
})
